import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FeatureDirective, I18nModule, UrlModule } from '@spartacus/core';
import { FormErrorsModule, IconModule, SpinnerModule } from '@spartacus/storefront';
import { LoginFormComponent } from '@spartacus/user/account/components';
import { CustomLogoModule } from '../../../../../../custom/cms-components/content/custom-logo/custom-logo.module';
import { CustomTabLoginModule } from '../../../../../../custom/cms-components/content/custom-tab-login/custom-tab-login.module';
import { ICON_TYPE } from '../../../../../../custom/icons/icon.model';
import { CustomLoginFormComponentService } from '../custom-login/service/login-form-component.service';

@Component({
  selector: 'app-custom-login-form',
  templateUrl: './custom-login-form.component.html',
  styleUrls: ['./custom-login-form.component.scss'],
  imports: [AsyncPipe, CustomLogoModule, CustomTabLoginModule, FormsModule, ReactiveFormsModule, RouterModule, UrlModule, I18nModule, FormErrorsModule, IconModule, SpinnerModule, FeatureDirective]
})
export class CustomLoginFormComponent extends LoginFormComponent {
  iconTypes = ICON_TYPE;
  showPassword = false;
  constructor(protected service: CustomLoginFormComponentService) {
    super(service);
  }
}
